// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import SectionHeader from 'components/SectionHeader';
import Link from 'components/Link';
import Button from 'components/Button';
import seideman3 from 'images/seideman-3.jpg';
import gender from 'icons/gender-symbol.svg';
import { sendEvent } from 'lib/analytics';

// local
import styles from './DsdSection.pcss';

const learnMore = 'https://www.ohsu.edu/doernbecher/doernbecher-sex-development-program';

export default class DsdSection extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}
  
  handleLearnMore = () => sendEvent('learn-more', 'dsd')
  
  render() {
    const { className } = this.props;
    
    const classNames = classnames(className, styles.dsdSection);
    
    return (
      <div
        id={ 'dsd' }
        className={ classNames }
      >
        <div className={ styles.imageWrap }>
          <div className={ styles.img }>
            <img alt={ 'doctor casey seideman' } src={ seideman3 } />
          </div>
        </div>
        
        <div className={ styles.content1 }>
          <SectionHeader className={ styles.title } image={ gender } imageClassname={ styles.icon }>
            <p className={ styles.short }>{ 'DSD' }</p>
            <p className={ styles.long }>{ 'Disorders of Sexual Differentiation' }</p>
          </SectionHeader>
          <p>
            { `
                Dr. Seideman is the co-director of a multidisciplinary clinic that specializes 
                in individualized treatment of patients (and families) with disorders of 
                sexual differentiation (DSD).
              ` }
          </p>

        </div>
        
        <div className={ styles.content2 }>
          <p>
            { `
                These conditions, such as congenital adrenal hyperplasia, 
                androgen insensitivity syndromes, mixed gonadal dysgenesis and others can 
                cause the development of ambiguous genitalia and hormonal abnormalities. 
                We work with families to develop a treatment plan to address the unique needs of each child.
              ` }
          </p>
            
          <Link
            className={ styles.learnMore }
            to={ learnMore }
            onClick={ this.handleLearnMore }
            title={ 'Learn more about disorders of sexual differentiation' }
          >
            <Button className={ styles.button } color={ 2 } tabIndex={ -1 }>{ 'Learn About DSD' }</Button>
          </Link>
        </div>
        
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DsdSection/index.jsx